module.exports = __webpack_public_path__ + "img/icon3.e7d449e6.png";